import { cn, getStatusColor } from '@/lib/utils';

type Variant = 'default' | 'online' | 'offline' | 'warning' | 'critical' | 'info';

export function Badge({ children, variant = 'default', className, dot }: {
  children: React.ReactNode;
  variant?: Variant | string;
  className?: string;
  dot?: boolean;
}) {
  const color = variant !== 'default' ? getStatusColor(variant) : undefined;
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded text-2xs font-medium px-1.5 py-0.5 border',
        variant === 'default' && 'bg-base-elevated text-text-secondary border-border',
        className,
      )}
      style={color ? { color, borderColor: color + '40', backgroundColor: color + '12' } : undefined}
    >
      {dot && <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: color }} />}
      {children}
    </span>
  );
}

export function StatusDot({ status }: { status: string }) {
  const color = getStatusColor(status);
  return (
    <span className="relative inline-flex h-2 w-2">
      {status === 'online' && (
        <span className="absolute inline-flex h-full w-full rounded-full opacity-60 animate-pulse-subtle" style={{ backgroundColor: color }} />
      )}
      <span className="relative inline-flex h-2 w-2 rounded-full" style={{ backgroundColor: color }} />
    </span>
  );
}
